import moment from 'moment';
import locale from "./locale";

export const FilterConstants = {
    TODAY: 'Today',
    TOMORROW: 'Tomorrow',
    YESTERDAY: 'Yesterday',
    PAST_7_DAYS: 'Past 7 days',
    PAST_30_DAYS: 'Past 30 days',
    NEXT_7_DAYS: 'Next 7 days',
    NEXT_30_DAYS: 'Next 30 days',
    YEAR_TO_DATE: 'Year to date',
    ALL_DATES: 'All dates',
    ALL_DATES_AND_TIMESLOTS: 'All dates and timeslots',
    CUSTOM: 'Custom',
    NEXT_TIMESLOT: 'Next Timeslot',
    CHOSEN_DATES: 'Chosen dates',
    ALL_TIMESLOTS: 'allTimeslots',
    SPECIFIC_TIMESLOT: 'specificTimeslot',
    RANGE_OF_TIMESLOTS: 'rangeOfTimeslots',
    SPECIFIC_START_ID: 'specificStart',
    RANGE_START_ID: 'rangeStart',
    RANGE_END_ID: 'rangeEnd',
    TIMESLOT_START_DATE: 'timeSlotStartDate',
    TIMESLOT_END_DATE: 'timeSlotEndDate',
    EVENTS_QUERY_LIMIT: 150,
    TICKETS: 'TICKET_TYPE_FILTER_TICKETS',
    ADD_ONS: 'TICKET_TYPE_FILTER_ADD_ONS',
    TICKETS_AND_ADD_ONS: 'TICKET_TYPE_FILTER_UNSPECIFIED'
  };

  export const FilterLocalizedStrings = (formatMessage, value) => {
    switch (value) {
      case FilterConstants.TODAY:
        return formatMessage(locale.today)
      case FilterConstants.TOMORROW:
        return formatMessage(locale.tomorrow)
      case FilterConstants.YESTERDAY:
        return formatMessage(locale.yesterday)
      case FilterConstants.PAST_7_DAYS:
        return formatMessage(locale.past7Days)
      case FilterConstants.PAST_30_DAYS:
        return formatMessage(locale.past30Days)
      case FilterConstants.NEXT_7_DAYS:
        return formatMessage(locale.next7Days)
      case FilterConstants.NEXT_30_DAYS:
        return formatMessage(locale.next30Days)
      case FilterConstants.ALL_DATES_AND_TIMESLOTS:
        return formatMessage(locale.allDatesAndTimeslots)
      case FilterConstants.YEAR_TO_DATE:
        return formatMessage(locale.yearToDate)
      case FilterConstants.NEXT_TIMESLOT:
        return formatMessage(locale.nextTimeslot)
      case FilterConstants.CUSTOM:
        return formatMessage(locale.custom)
      default:
        return formatMessage(locale.allDates)
    }
  }

  export const getDateOfOrderFilterContext = (
    chosenRange,
    value
  ) => {
    switch (value) {
      case FilterConstants.TODAY:
        return {
          minPurchaseDate: moment().startOf('day').utcOffset(0, true),
          maxPurchaseDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.YESTERDAY:
        return {
          minPurchaseDate: moment().startOf('day').subtract(1, 'day').utcOffset(0, true),
          maxPurchaseDate: moment().endOf('day').subtract(1, 'day').utcOffset(0, true)
        }
      case FilterConstants.PAST_7_DAYS:
        return {
          minPurchaseDate: moment().startOf('day').subtract(7, 'day').utcOffset(0, true),
          maxPurchaseDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.PAST_30_DAYS:
        return {
          minPurchaseDate: moment().startOf('day').subtract(30, 'day').utcOffset(0, true),
          maxPurchaseDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.YEAR_TO_DATE:
        return {
          minPurchaseDate: moment().startOf('year').utcOffset(0, true),
          maxPurchaseDate: moment().endOf('day').utcOffset(0, true)
        }
      // eslint-disable-next-line no-case-declarations
      case FilterConstants.CHOSEN_DATES:
        const startDate = chosenRange.startDate.clone()
        const endDate = chosenRange.endDate
          ? chosenRange.endDate.clone()
          : startDate.clone()

        // Ensure the dates align to the beginning and end of the chosen day.
        return {
          minPurchaseDate: startDate.startOf('day').utcOffset(0, true),
          maxPurchaseDate: endDate.endOf('day').utcOffset(0, true)
        }
      default :
        return {
          minPurchaseDate: '',
          maxPurchaseDate: ''
        }
    }
  }

  export const getDateOfAttendanceRangeFilterContext = (
    chosenRange,
    value
  ) => {
    switch (value) {
      // eslint-disable-next-line no-case-declarations
      case FilterConstants.CUSTOM:
        const startDate = chosenRange.startDate.clone()
        const endDate = chosenRange.endDate
          ? chosenRange.endDate.clone()
          : startDate.clone()

        // Ensure the dates align to the beginning and end of the chosen day.
        return {
          minAttendanceDate: startDate.startOf('day').utcOffset(0, true),
          maxAttendanceDate: endDate.endOf('day').utcOffset(0, true)
        }
      case FilterConstants.TODAY:
        return {
          minAttendanceDate: moment().startOf('day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.TOMORROW:
        return {
          minAttendanceDate: moment().startOf('day').add(1, 'day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').add(1, 'day').utcOffset(0, true)
        }
      case FilterConstants.YESTERDAY:
        return {
          minAttendanceDate: moment().startOf('day').subtract(1, 'day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').subtract(1, 'day').utcOffset(0, true)
        }
      case FilterConstants.PAST_7_DAYS:
        return {
          minAttendanceDate: moment().startOf('day').subtract(7, 'day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.PAST_30_DAYS:
        return {
          minAttendanceDate: moment().startOf('day').subtract(30, 'day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.NEXT_7_DAYS:
        return {
          minAttendanceDate: moment().startOf('day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').add(7, 'day').utcOffset(0, true)
        }
      case FilterConstants.NEXT_30_DAYS:
        return {
          minAttendanceDate: moment().startOf('day').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').add(30, 'day').utcOffset(0, true)
        }
      case FilterConstants.YEAR_TO_DATE:
        return {
          minAttendanceDate: moment().startOf('year').utcOffset(0, true),
          maxAttendanceDate: moment().endOf('day').utcOffset(0, true)
        }
      case FilterConstants.NEXT_TIMESLOT:
        return {
          minAttendanceDate: moment.utc(chosenRange.startAt),
          maxAttendanceDate: moment.utc(chosenRange.endAt)}
      default: // ALL_DATES
        return {
          minAttendanceDate: '',
          maxAttendanceDate: ''}
    }
  }
